import { createFileRoute } from '@tanstack/react-router';
import { queryClient } from '@/lib/utils/queryClient';
import { AdminGeneralInfoTab } from '../../../-components/AdminGeneralInfoTab';
import {
  adminCompanyProfileQueryOptions,
  GENERAL_INFO_TEMPLATE_IDS,
} from '../../../-hooks/useAdminGeneralInfo';

export const Route = createFileRoute(
  '/management/companies/(pages)/$companyId/general-info/',
)({
  // All three templates: the tab shows one at a time but counts fields across
  // every one of them in its sidebar.
  loader: ({ params }) =>
    Promise.all(
      GENERAL_INFO_TEMPLATE_IDS.map(templateId =>
        queryClient.ensureQueryData(
          adminCompanyProfileQueryOptions(params.companyId, templateId),
        ),
      ),
    )
      // A failed prefetch must not blank the tab — the component's own query
      // re-runs and surfaces the error inline.
      .catch(() => undefined),
  component: CompanyGeneralInfoPage,
});

function CompanyGeneralInfoPage() {
  const { companyId } = Route.useParams();
  return <AdminGeneralInfoTab companyId={companyId} />;
}
